import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/pay-equity", label: "Pay Equity" },
  { to: "/fractional-hr", label: "Fractional HR" },
  { to: "/wage-studies", label: "Wage Studies" },
  { to: "/toolkits", label: "Toolkits" },
  { to: "/about", label: "About" },
  { to: "/resources", label: "Resources" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 bg-cream/95 backdrop-blur-md transition-shadow duration-300 ${
        scrolled ? "shadow-[0_1px_0_0_#E6E8EB,0_8px_24px_-16px_rgba(15,45,69,0.25)]" : "border-b border-forest-700"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="/" data-testid="logo-link" className="flex items-center group">
          <img src="/cascade-logo-long.png" alt="Cascade HR Advisors" className="h-11 w-auto transition-transform duration-300 group-hover:scale-[1.02]" />
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.to}
              href={l.to}
              data-testid={`nav-${l.to.slice(1)}`}
              className={`text-sm font-semibold tracking-wide transition-colors duration-300 hover:text-orange ${
                pathname === l.to ? "text-orange" : "text-navy"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="/contact"
            data-testid="nav-book-call"
            className="text-sm font-bold bg-orange text-navy px-5 py-2.5 rounded-md transition-colors duration-300 hover:bg-orange-dark"
          >
            Book a Call
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-navy"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-cream border-t border-forest-700 px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a key={l.to} href={l.to} className="text-navy font-semibold text-base" data-testid={`mnav-${l.to.slice(1)}`}>
              {l.label}
            </a>
          ))}
          <a href="/contact" className="text-orange font-bold" data-testid="mnav-contact">
            Book a Call
          </a>
        </div>
      )}
    </header>
  );
};
